// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.objectIcon{pointer-events:none;border-radius:4px}`, "",{"version":3,"sources":["webpack://./src/taskpane/components/shared/ObjectIcons.scss"],"names":[],"mappings":"AAAA,YACI,mBAAA,CACA,iBAAA","sourcesContent":[".objectIcon {\n    pointer-events: none;\n    border-radius: 4px; \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
